export default __webpack_public_path__ + "cache-tile-fetching-scheme-960-7b2a0dc21b3568aa92fb2a1a6e14683c.png";